import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-block text-xs uppercase tracking-[0.2em] font-semibold text-brand-gold ${className}`}>
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, subtitle, center = false, light = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && <Overline>{overline}</Overline>}
    <h2 className={`font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight mt-3 ${light ? "text-white" : "text-brand-green"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-white/70" : "text-brand-muted"}`}>{subtitle}</p>}
  </div>
);
